import React from "react";
import { useTheme } from "@mui/material/styles";

export default ({ color }) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.dark;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.465"
      height="37.512"
      viewBox="0 0 29.465 37.512"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_6631"
            data-name="Rectangle 6631"
            width="29.465"
            height="37.512"
            transform="translate(0 0)"
            fill={color}
          />
        </clipPath>
      </defs>
      <g id="Group_7185" data-name="Group 7185" transform="translate(0 0)">
        <g id="Group_7184" data-name="Group 7184" clip-path="url(#clip-path)">
          <path
            id="Path_8219"
            data-name="Path 8219"
            d="M25.965,37.512h-20v-3h20a.5.5,0,0,0,.5-.5v-28h3v28a3.5,3.5,0,0,1-3.5,3.5"
            fill={color}
          />
          <path
            id="Path_8220"
            data-name="Path 8220"
            d="M21,11.478V29H3V3H21v9.179h3V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V30a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V11.478Z"
            fill={color}
          />
          <path
            id="Path_8221"
            data-name="Path 8221"
            d="M18,9.261v3.587H15.929l-.11-1.507H13.341v9.484l1.442.278v1.618H9.2V21.1l1.442-.278V11.341H8.173l-.111,1.507H6V9.261Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};
